import request from '@/utils/request';

// 获取列表
export function List(params) {
    return request({
        url: '/wisc/report/page',
        method: 'GET',
        params: params
    });
}

// 关联数据
export function Binding(params) {
    return request({
        url: '/wisc/report/binding',
        method: 'GET',
        params: params
    });
}

// 创建导出任务
export function CreateExport(params) {
    return request({
        url: '/wisc/report/export',
        method: 'GET',
        params
    });
}

// 获取导出进度
export function ExportProgress(params) {
    return request({
        url: '/wisc/report/exportProgress',
        method: 'GET',
        params
    });
}

// 下载导出文件
export function ExportDownload(params) {
    return request({
        url: '/wisc/report/exportDownload',
        method: 'GET',
        params,
        responseType: 'blob'
    });
}
